import React, { useEffect, useState } from 'react';
import { getBrief, saveBrief, updateOrder } from '../services/portalService';

const FIELDS = [
  { key: 'goals', label: 'Project goals', type: 'textarea', placeholder: 'What outcome do you want? What problem does this solve?' },
  { key: 'scope', label: 'Scope & key features', type: 'textarea', placeholder: 'Pages, features, integrations, platforms…' },
  { key: 'audience', label: 'Target audience', type: 'input', placeholder: 'Who is this for?' },
  { key: 'references', label: 'References / inspiration', type: 'textarea', placeholder: 'Links to sites, designs, or competitors you like' },
  { key: 'deadline', label: 'Desired deadline', type: 'date' },
  { key: 'budget', label: 'Budget notes (optional)', type: 'input', placeholder: 'Any constraints we should know' },
  { key: 'links', label: 'Assets & links', type: 'textarea', placeholder: 'Brand assets, docs, Figma, repo, etc.' },
];

const BriefForm = ({ order, onSaved }) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getBrief(order.id)
      .then((b) => { setContent(b?.content || {}); })
      .catch(() => { setContent({}); })
      .finally(() => { setLoading(false); });
  }, [order.id]);

  const set = (k, v) => { setContent((c) => ({ ...c, [k]: v })); setSaved(false); };

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true); setError('');
    try {
      await saveBrief(order.id, content);
      if (order.status === 'brief_pending') {
        await updateOrder(order.id, { status: 'awaiting_payment' });
      }
      setSaved(true);
      onSaved && onSaved(content);
    } catch (e2) {
      setError(e2.message || 'Could not save your brief');
    }
    setSaving(false);
  };

  if (loading) return <div className="portal-spinner" />;

  return (
    <form onSubmit={submit} className="portal-card">
      <p className="portal-eyebrow" style={{ marginBottom: 4 }}>Project brief</p>
      <p className="portal-muted" style={{ marginBottom: 22 }}>
        Tell us about your project. Your AI project manager uses this to draft a plan and milestones.
      </p>
      {FIELDS.map((f) => (
        <div className="portal-field" key={f.key}>
          <label className="portal-label">{f.label}</label>
          {f.type === 'textarea' ? (
            <textarea className="portal-textarea" value={content[f.key] || ''} placeholder={f.placeholder}
              onChange={(e) => set(f.key, e.target.value)} />
          ) : (
            <input className="portal-input" type={f.type === 'date' ? 'date' : 'text'} value={content[f.key] || ''}
              placeholder={f.placeholder} onChange={(e) => set(f.key, e.target.value)} />
          )}
        </div>
      ))}
      {error && <p style={{ color: 'var(--v2-color-error)', fontSize: 12 }}>{error}</p>}
      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <button type="submit" className="portal-btn portal-btn-primary" disabled={saving}>
          {saving ? 'Saving…' : 'Save brief'}
        </button>
        {saved && <span className="portal-muted" style={{ color: 'var(--v2-color-orange)' }}>✓ Saved — open the Manager tab to generate your plan</span>}
      </div>
    </form>
  );
};

export default BriefForm;
